import {applyMiddleware, combineReducers, compose, createStore} from 'redux';
import promise from 'redux-promise';
import thunk from 'redux-thunk'
import {apiMiddleware} from 'redux-api-middleware';
import { reducer as formReducer } from 'redux-form'
import {createErrorReporterMiddleware} from '@common/helpers/installGlobalErrorReporter';
import ModalReducer from "./ModalReducer";
import PaymentReducer from "./PaymentReducer";
import FileFormReducer from "./FileFormReducer";
import FileReducer from "./FileReducer";

const composeEnhancers =
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
            // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
        }) : compose;

const coreMiddleware = [
    promise,
    apiMiddleware,
    thunk,
    createErrorReporterMiddleware(),
];

const coreReducers = {
    form: formReducer,
    modal: ModalReducer,
    payment: PaymentReducer,
    fileForm: FileFormReducer,
    file: FileReducer,
};

export default function configureStore(reducers, initialState, middleware = []) {
    const rootReducer = combineReducers({
        ...coreReducers,
        ...reducers,
    });

    const enhancer = composeEnhancers(
        applyMiddleware(...coreMiddleware.concat(middleware)),
    );

    return createStore(rootReducer, initialState, enhancer);
};